import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { getNodeById } from "@reducers/nodes/thunk/nodes-thunk";
import { setSelectedNode } from "@reducers/nodes/slice/nodes-slice";
export const useNodeData = (nodeId) => {
    const dispatch = useAppDispatch();
    const hasFetched = useRef(false);
    const { selectedNode: node, singleLoading: loading, singleError: error, } = useAppSelector((state) => state.nodes);
    const isEdit = Boolean(nodeId);
    useEffect(() => {
        if (nodeId) {
            // Prevent duplicate fetches (React Strict Mode calls effects twice)
            if (hasFetched.current) {
                hasFetched.current = false;
                return;
            }
            dispatch(getNodeById(nodeId));
            hasFetched.current = true;
            // Reset after a short delay
            const timeout = setTimeout(() => {
                hasFetched.current = false;
            }, 100);
            return () => {
                clearTimeout(timeout);
                dispatch(setSelectedNode(null));
            };
        }
        else {
            // New node - clear selected node
            dispatch(setSelectedNode(null));
        }
    }, [nodeId, dispatch]);
    const nodeExists = !isEdit || (isEdit && node !== null && !error);
    return {
        node,
        loading,
        error,
        nodeExists,
        isEdit,
    };
};
